import { ReactComponent as ProfileManagementIcon } from "../assets/icons/sidebar-profile-management.svg";
import { ReactComponent as ProcedureManagementIcon } from "../assets/icons/sidebar-procedure-management.svg";
import { ReactComponent as IpMarketplaceIcon } from "../assets/icons/sidebar-ip-marketplace.svg";
import { ReactComponent as AccountManagementIcon } from "../assets/icons/sidebar-account-management.svg";
import { ReactComponent as IpCategoryIcon } from "../assets/icons/sidebar-ip-category.svg";
import { ReactComponent as DocumentsIcon } from "../assets/icons/sidebar-documents.svg";
import { ReactComponent as ServicesIcon } from "../assets/icons/sidebar-services.svg";
import { ReactComponent as StatisticsIcon } from "../assets/icons/sidebar-statistics.svg";
import { ReactComponent as CustomerManagementIcon } from "../assets/icons/sidebar-customer-management.svg";
import { ReactComponent as DepartmentManagementIcon } from "../assets/icons/sidebar-department-management.svg";
import { ReactComponent as ApprovalManagementIcon } from "../assets/icons/sidebar-approval-management.svg";
import { ReactComponent as OrderManagementIcon } from "../assets/icons/sidebar-order-management.svg";
import { ReactComponent as BannerManagementIcon } from "../assets/icons/sidebar-banner-management.svg";

export const SIDEBAR_ROUTE_MAP = {
  quan_ly_ho_so: "/quan-ly-ho-so",
  quan_ly_khach_hang: "/quan-ly-khach-hang",
  dich_vu: "#",
  quan_ly_thu_tuc: "/quan-ly-thu-tuc",
  quan_ly_phong_ban: "/quan-ly-phong-ban",
  quan_ly_banner: "/quan-ly-banner",
  mua_ban_so_huu_tri_tue: "/mua-ban-so-huu-tri-tue",
  quan_ly_tai_khoan: "#",
  danh_sach_dich_vu: "/quan-ly-dich-vu",
  loai_dich_vu: "/loai-dich-vu",
  tai_khoan_cua_toi: "/tai-khoan-cua-toi",
  danh_sach_tai_khoan: "/danh-sach-tai-khoan",
  quan_ly_xet_duyet: "/quan-ly-xet-duyet",
  quan_ly_don_hang: "/quan-ly-don-hang",
  bao_cao_tong_quan: "/bao-cao-tong-quan",
  bao_cao_dich_vu: "/bao-cao-dich-vu",
  bao_cao_ho_so: "/bao-cao-ho-so",
  danh_muc_tai_san_tri_tue: "/danh-muc-tai-san-tri-tue",
  bao_cao_tai_chinh: "/bao-cao-tai-chinh",
  cau_hinh_vat: "/cau-hinh-vat", 
  quan_ly_tai_lieu: "/quan-ly-tai-lieu"
};

export const SIDEBAR_ICON_MAP = {
  quan_ly_ho_so: <ProfileManagementIcon />,
  quan_ly_khach_hang: <CustomerManagementIcon />,
  dich_vu: <ServicesIcon />,
  quan_ly_thu_tuc: <ProcedureManagementIcon />,
  quan_ly_banner: <BannerManagementIcon />,
  mua_ban_so_huu_tri_tue: <IpMarketplaceIcon />,
  quan_ly_tai_khoan: <AccountManagementIcon />,
  quan_ly_phong_ban: <DepartmentManagementIcon />,
  quan_ly_xet_duyet: <ApprovalManagementIcon />,
  quan_ly_don_hang: <OrderManagementIcon />,
  bao_cao_thong_ke: <StatisticsIcon />,
  danh_muc_tai_san_tri_tue: <IpCategoryIcon />,
  quan_ly_tai_lieu: <DocumentsIcon />,
};
